export default __webpack_public_path__ + "static/media/racepace.0d37b089.png";